import React from 'react';
import { Member } from '../../../../../types/member';
import {
  FontWeightType, LabelLarge, LabelMedium, LabelSmall,
} from '../../../../../component/Text';
import { formatName } from '../../../../../util/format';
import { useMobile } from '../../../../../hook/usePlatform';

export interface UserBaseProfileProps {
  user:Member
}
const UserBaseProfile: React.FC<UserBaseProfileProps> = (props) => {
  const isMobile = useMobile();
  return  (
    <div style={{ display: 'flex', gap: 16 }}>
      <div
        style={{
          backgroundColor: 'white',
          width: isMobile ? 140 : 165,
          height: isMobile ? 170 : 197,
          paddingInline: isMobile ? 10 : 20,
          paddingTop: isMobile ? 10 : 20,
          paddingBottom: isMobile ? 20 : 40,
        }}
      >
        <img
          alt=""
          src={props.user.photos?.filter((e) => e.main || e.isMain)?.[0]?.url}
          width="100%"
          height="100%"
        />
      </div>
      <div style={{ flex: 1 }}>
        <LabelLarge style={{ fontFamily: 'inter' }} fontWeight={FontWeightType.w800}>
          {formatName(props.user.name)}
          {'\n'}
          (
          {props.user.additionalInfo?.public?.birthday ? `${new Date(props.user.additionalInfo?.public?.birthday).getFullYear()}년생 / ` : ''}
          {props.user.additionalInfo?.public?.address?.split(' ').slice(0, 2).join(' ')}
          )
        </LabelLarge>
        <ProfileItem title="직업" value={props.user.additionalInfo?.public?.work?.name} />
        <ProfileItem title="최종학력" value={props.user.additionalInfo?.public?.educate?.finalEducate} />
        <ProfileItem title="혼인상태" value={props.user.additionalInfo?.public?.marryHistory} />
        <ProfileItem title="신장" value={`${props.user.additionalInfo?.public?.health?.height ?? 0}cm`} />
        <ProfileItem title="종교" value={props.user.additionalInfo?.public?.health?.religion} />
      </div>
    </div>
  );
};

const ProfileItem = ({ title, value } :  { title:string, value:string | null | undefined }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: 6 }}>
    <LabelMedium style={{ color: '#5F4E32', flex: 1, fontFamily: 'inter' }}>{title}</LabelMedium>
    <LabelMedium style={{  flex: 2, fontFamily: 'inter' }}>{value ?? ''}</LabelMedium>
  </div>
);
export default UserBaseProfile;
